import {
  GET_ALL_LISTS,
  GET_LIST,
  GET_LIST_ENTRIES,
  SET_LIST_ENTRY,
} from './../../mutation-types';

export default {
  [GET_ALL_LISTS](state, lresp) {
    state.all_lists = lresp;
  },
  [GET_LIST](state, listresp) {
    state.thislist = listresp;
  },
  [GET_LIST_ENTRIES](state, listentries) {
    state.listentries_list_id = listentries.list_id;
    state.listentries_pageinfo = listentries.pageinfo;
    state.listentries = listentries.data;
    for (let i = 0; i < listentries.data.length; i += 1) {
      state.listentries[i].orig_domain = listentries.data[i].domain;
      state.listentries[i].orig_path = listentries.data[i].path;
      // if (listentries.data[i].path === '') {
      //   listentries.data[i].path = '/';
      // }
      state.listentries[i].fullurl = state.listentries[i].domain + state.listentries[i].path;
    }
  },
  [SET_LIST_ENTRY](state, updateObj) {
    state.listentries[updateObj.index] = updateObj.object;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/lists/mutations.js